import { render } from "./LoginRegisterNav.vue?vue&type=template&id=6bae175e&scoped=true"
import script from "./LoginRegisterNav.vue?vue&type=script&lang=js"
export * from "./LoginRegisterNav.vue?vue&type=script&lang=js"

import "./LoginRegisterNav.vue?vue&type=style&index=0&id=6bae175e&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bae175e"]])

export default __exports__